import { useTranslation } from "react-i18next";
import styles from "./mobile-menu-action-bar.module.less";

type TMobileMenuActionBarProps = {
  onClickClose: () => void;
  onClickBack?: () => void;
};

const MobileMenuActionBar = ({ onClickBack, onClickClose }: TMobileMenuActionBarProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.actionBarWrapper}>
      {typeof onClickBack === "function" && (
        <button onClick={onClickBack} className={[styles.actionButton].join(" ")}>
          <span className={[styles.icon, styles.iconBack, "ui-icon-arrow-left"].join(" ")} />
        </button>
      )}
      {typeof onClickClose === "function" && (
        <button onClick={onClickClose} className={[styles.actionButton, styles.closeButton].join(" ")}>
          <span className={[styles.icon, styles.iconClose, "ui-icon-close"].join(" ")} />
          <div className={"body-base mb-0"}>{t("CLOSE")}</div>
        </button>
      )}
    </div>
  );
};

export default MobileMenuActionBar;
